import React, { useEffect } from "react";
import styles from "./Modal.module.css";

const Modal = ({ show, onClose, children }) => {
  useEffect(() => {
    if (show) {
      // Store current scroll position
      const scrollY = window.scrollY;

      document.body.style.cssText = `
        position: fixed;
        top: -${scrollY}px;
        left: 0;
        width: 100%;
        overflow: hidden;
      `;

      return () => {
        // Get back to the same scroll position when modal closes
        const storedScrollY = parseInt(document.body.style.top || "0", 10);
        document.body.style.cssText = "";
        window.scrollTo({ top: -storedScrollY, behavior: "instant" });
      };
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.closeButton} onClick={onClose}>
          X
        </div>
        <div className={styles.modalContent}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
